import './SocialLoginComponentStyles.scss';
import { FC, useContext, useEffect, useRef, useState } from "react";
import Icons from "../../assets/Icons";
import { isRight } from "fp-ts/lib/Either";
import di from "../../../di/DependencyInjection";
import SignInWithActiveDirectoryUseCase, { SignInWithActiveDirectoryUseCaseName } from "../../../domain/use_cases/auth/SignInWithActiveDirectoryUseCase";
import KeyWordLocalization from "../../providers/localization/dictionaries/KeyWordLocalization";
import { routes } from "../../routes/RoutesComponent";
import { useNavigate } from "react-router-dom";
import LocalizationContext from "../../../domain/providers/localization/LocalizationContext";
import LocalizationContextType from "../../../domain/providers/localization/LocalizationContextType";
import ModalsContext from "../../../domain/providers/modal/ModalsContext";
import ModalsContextType from "../../../domain/providers/modal/ModalsContextType";
import disclamerImage from "../../assets/disclaimer.png";

const LOCAL_STORAGE_MODAL_KEY = 'modal_accepted';

const SocialLoginComponent: FC<{}> = () => {
    const navigate = useNavigate();
    const { addToast } = useContext(ModalsContext) as ModalsContextType;
    const { i18n } = useContext(LocalizationContext) as LocalizationContextType;

    const [showModal, setShowModal] = useState<boolean>(false);
    const [pendingSocialLogin, setPendingSocialLogin] = useState<boolean>(false);
    const hasAcceptedModal = useRef<boolean>(false);

    useEffect(() => {
        hasAcceptedModal.current = false;
    }, []);

    const handleModalAccept = async () => {
        localStorage.setItem(LOCAL_STORAGE_MODAL_KEY, 'true');
        setShowModal(false);
        hasAcceptedModal.current = true;

        if (pendingSocialLogin) {
            await proceedWithActiveDirectoryLogin();
            setPendingSocialLogin(false);
        }
    };

    const handleClick = async () => {
        if (!hasAcceptedModal.current) {
            setPendingSocialLogin(true);
            setShowModal(true);
        } else {
            await proceedWithActiveDirectoryLogin();
        }
    };

    const proceedWithActiveDirectoryLogin = async () => {
        const response = await di.get<SignInWithActiveDirectoryUseCase>(SignInWithActiveDirectoryUseCaseName).call();

        if (isRight(response)) {
            if (!(response.right?.permissions?.employee != undefined)) {
                navigate(routes.rolesAndPermissions.relativePath);
            } else {
                navigate(routes.home.relativePath);
            }
        } else {
            if (response.left.code != undefined) {
                addToast(i18n(response.left.code), 'error', null, true);
            }
        }
    };

    return (
        <div className="social_login_component">
            {/* Modal */}
            {showModal && (
                <div className="custom-modal-backdrop">
                    <div className="custom-modal">
                        <img
                            src={disclamerImage} // Replace with your actual image path
                            alt="Modal Notice"
                            className="modal-image"
                        />
                        <button className="btn btn_primary" onClick={handleModalAccept}>
                            Accept
                        </button>
                    </div>
                </div>
            )}

            <div className="py-3 o_container text-center">
                <div>{i18n(KeyWordLocalization.SocialLoginComponentOr)}</div>
            </div>
            <div className="btn btn_light w-100" onClick={handleClick}>
                <Icons.MicrosoftShort />
                <span className='ms-2'>{i18n(KeyWordLocalization.SocialLoginComponentSignInWithMicrosoft)}</span>
            </div>
        </div>
    );
};

export default SocialLoginComponent;
